import React from 'react';
import Styles from './MeuFinanciamentoImobiliario.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';

function MeuFinanciamentoImobiliario() {
  return (
    <section id="financiamento-imobiliario">
      <picture className="is-mob">
        <source type="image/webp" srcSet="assets/meu-financiamento/banner-imobiliario.webp" />
        <source type="image/png" srcSet="assets/meu-financiamento/banner-imobiliario.png" />
        <img
          className="imobiliario-banner"
          src="assets/meu-financiamento/banner-imobiliario.png"
          alt="Prédios e casas espalhados por cidade com vegetação ao redor do Banco Santander"
        />
        <div className="fade-banner" />
        <div className="fade-banner-gradiente" />
      </picture>

      <ContainerHome24>
        <picture className="is-desk">
          <source type="image/webp" srcSet="assets/meu-financiamento/banner-imobiliario.webp" />
          <source type="image/png" srcSet="assets/meu-financiamento/banner-imobiliario.png" />
          <img
            className="imobiliario-banner"
            src="assets/meu-financiamento/banner-imobiliario.png"
            alt="Prédios e casas espalhados por cidade com vegetação ao redor do Banco Santander"
          />
          {/* <div className="fade-banner" /> */}
          {/* <div className="fade-banner-gradiente" /> */}
        </picture>

        <h3 className="imobiliario-titulo">Financiamento imobiliário</h3>
        <p className="imobiliario-paragrafo">
          Se você realizou um <b>financiamento imobiliário</b> com o Santander, você também possui
          acesso a diversos serviços clicando no botão abaixo.
        </p>
        <RedButton
          href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento:imobiliario&int_campaign=acessar-area-do-cliente"
          target="_blank"
          className="imobiliario-btn"
        >
          Acessar área do cliente
        </RedButton>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default MeuFinanciamentoImobiliario;
